








import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class Search extends Vue {
  @Prop()
  placeholder: string;

  @Prop()
  onUpdate: (value: string) => void;

  @Prop()
  onSubmit: (value: string) => void;

  searchTerm = "";

  onSearch (e) {
    e.preventDefault();
    this.onSubmit(this.searchTerm);
  }

  onTermUpdate (e) {
    if (this.onUpdate) {
      this.onUpdate(this.searchTerm);
    }
  }
}

